module.exports = __webpack_public_path__ + "static/transepi_featured.f01fd004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/research/transepi_featured.jpg
// module id = 391
// module chunks = 99330344035853 176293843571754